import { seller } from './seller'
import { sellerInfo } from './sellerInfo'
import { sellerStatement } from './sellerStatement'

export const sellerService = {
  seller,
  sellerInfo,
  sellerStatement,
}
